import React, { PureComponent, Fragment } from 'react';

import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Header } from 'formlabs-web-components/Type';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import List from './List';

import './Resources.module.css';

const ResourceCollectionList = DisplayComponent(
  class ResourceCollectionList extends PureComponent {
    render() {
      const { subCollections, classes } = this.props;

      return (
        <Grid direction="x" hasContainer={true}>
          {subCollections.map(subCollection => {
            if (!subCollection.resources.length) {
              return null;
            }

            return (
              <Fragment key={subCollection.title}>
                {subCollection.title !== 'Default' && (
                  <Cell largeSize={24}>
                    <div styleName="filter-stories" className={classes}>
                      <span styleName="stories-header">
                        <Header level={4} displayAs={4}>
                          {subCollection.title}
                        </Header>
                      </span>
                    </div>
                  </Cell>
                )}
                <Cell largeSize={24}>
                  <List resources={subCollection.resources} />
                </Cell>
              </Fragment>
            );
          })}
        </Grid>
      );
    }
  }
);

export default ResourceCollectionList;
